import React from "react";

export default function Clock() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0.46875C3.25391 0.46875 0.21875 3.50391 0.21875 7.25C0.21875 10.9961 3.25391 14.0312 7 14.0312C10.7461 14.0312 13.7812 10.9961 13.7812 7.25C13.7812 3.50391 10.7461 0.46875 7 0.46875ZM7 12.7188C3.96484 12.7188 1.53125 10.2852 1.53125 7.25C1.53125 4.24219 3.96484 1.78125 7 1.78125C10.0078 1.78125 12.4688 4.24219 12.4688 7.25C12.4688 10.2852 10.0078 12.7188 7 12.7188ZM8.66797 9.875C8.83203 9.98438 9.02344 9.95703 9.13281 9.79297L9.65234 9.10938C9.76172 8.94531 9.73438 8.75391 9.57031 8.64453L7.76562 7.30469V3.42188C7.76562 3.25781 7.60156 3.09375 7.4375 3.09375H6.5625C6.37109 3.09375 6.23438 3.25781 6.23438 3.42188V7.93359C6.23438 8.01562 6.26172 8.125 6.34375 8.17969L8.66797 9.875Z"
        fill="currentColor"
      />
    </svg>
  );
}
